import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { ExecutionTerminateTypes } from "../ea.enums";
import type { StartBackgroundSessionParams } from "../ea.runner.types";

const base = "execution";
const execution = createEndpointBase(base);

export const executionEndpoints = {
  executionTerminate: execution({
    method: "POST",
    path: "terminate",
    request: z.object({ type: z.nativeEnum(ExecutionTerminateTypes), ids: z.array(z.string()) }),
    response: z.any(),
    description: "Terminates running executions based on specified IDs and type.",
  }),
  executionRun: execution({
    method: "POST",
    path: "run",
    request: z.any(),
    response: z.any(),
    requestType: {} as any as Partial<StartBackgroundSessionParams>,
    description: "Starts an immediate script execution.",
  }),
} as const;
